export enum WaybillNoType {
    EWAYBILL = "EWAYBILL",
    MANUAL = "MANUAL",
    DROP_SHIPPING = "DROP_SHIPPING",
    UNPRINTED_EWAYBILL = "UNPRINTED_EWAYBILL",
}
